module.exports = __webpack_public_path__ + "05_glasses_black.f9760fc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer4/05_glasses_black.png
// module id = D115
// module chunks = 0